module.exports = __webpack_public_path__ + "img/sweden.6be940be.svg";